__turbopack_context__.v({
  "shimmer": "XwM0Vq_shimmer",
  "shimmer-pulse": "XwM0Vq_shimmer-pulse",
  "shimmer-sweep": "XwM0Vq_shimmer-sweep",
});
